import { TableColumnDef } from '../../../utils/tableColumns';
import { MemberSortField } from '../types';

export type DisengagedColumnId =
    | 'member'
    | 'patientId'
    | 'memberSince'
    | 'primaryReason'
    | 'secondaryReasons'
    | 'careManager'
    | 'device'
    | 'status'
    | 'membership'
    | 'role';

/** Single source of truth for the Disengaged members list columns. */
export const DISENGAGED_COLUMNS: TableColumnDef<DisengagedColumnId, MemberSortField>[] = [
    { id: 'member', label: 'Member', size: '4fr', alwaysVisible: true, sortField: 'last_name' },
    { id: 'patientId', label: 'Patient ID', size: '1.5fr', defaultVisible: false },
    {
        id: 'memberSince',
        label: 'Member since',
        size: '1.8fr',
        defaultVisible: false,
        sortField: 'activated_at'
    },
    { id: 'primaryReason', label: 'Primary Reason', size: '2fr' },
    { id: 'secondaryReasons', label: 'Secondary Reasons', size: '3fr' },
    { id: 'careManager', label: 'Care Manager', size: '2.4fr' },
    { id: 'device', label: 'Device ID', size: '1.8fr', defaultVisible: false },
    { id: 'status', label: 'Device Status', size: '1.6fr', defaultVisible: false },
    { id: 'membership', label: 'Membership', size: '1.6fr', defaultVisible: false },
    { id: 'role', label: 'Role', size: '2.2fr', defaultVisible: false }
];

export const DISENGAGED_COLUMNS_STORAGE_KEY = 'ep:columns:disengaged-members';

/** Trailing track reserved for the conditional disengagement alert icon. */
export const DISENGAGED_TRAILING_TRACK = '1fr';
